// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import Select from '../controls/Select'
import LabeledWrapper from './LabeledWrapper'
import biddingModeOptions from './biddingModeOptions'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  width: 330px;
`

type Props = {|
  className: string,
  provider: string,
  paymentType: string,
  value: string,
  onChange: Function
|}

const t = {
  facebook: 'Facebook',
  label: 'Стратегия ставок для',
  target_mail: 'МТ',
  vk: 'ВК'
}

export default class BiddingModeSelect extends Component<Props> {
  render() {
    const { className, provider, value, onChange } = this.props
    return (
      <LabeledWrapper label={`${t.label} ${t[provider]}`} twoLines>
        <Wrapper className={className}>
          <Select
            options={biddingModeOptions(this.props.provider, this.props.paymentType)}
            value={value}
            onChange={(biddingMode) => onChange(biddingMode)}
          />
        </Wrapper>
      </LabeledWrapper>
    )
  }
}
